import { render, staticRenderFns } from "./veSbzcCdRevertEdit.vue?vue&type=template&id=517c0fbc&scoped=true"
import script from "./veSbzcCdRevertEdit.vue?vue&type=script&lang=js"
export * from "./veSbzcCdRevertEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517c0fbc",
  null
  
)

export default component.exports